// extracted by mini-css-extract-plugin
export default {"InviteFriendPop":"AssignDriverPop_InviteFriendPop__-pp4F","modalHeader":"AssignDriverPop_modalHeader__h3nmB","formControl":"AssignDriverPop_formControl__nR6+X"};